export default __webpack_public_path__ + "static/media/p2.2a48c2c7.png";